import api from './request'

export const createSession = async (experienceId: number, mode: string) => {
  const response = await api.post('/sessions', {
    experience: experienceId,
    mode,
  })
  return response.data
}

export const endSession = async (sessionId: number) => {
  const response = await api.patch(`/sessions/${sessionId}`, {
    end: new Date().toISOString(),
  })
  return response.data
}
